// extracted by mini-css-extract-plugin
export default {"cls1":"VeloDatePicker-DatePicker_cls1__m4VLX","cls2":"VeloDatePicker-DatePicker_cls2__t4tSv VeloDatePicker-DatePicker_cls1__m4VLX"};